import React from 'react';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  HeaderText,
  PortalOverlayHeaderCloseBtn,
} from '../../../../ui';

export type FraudBannerProps = {
  editType?: string;
  onDismiss: () => void;
};

const FraudBanner: React.FC<FraudBannerProps> = ({
  editType,
  onDismiss,
}) => (
  <Inline
    padding={16}
    color={colors.slate}
    alignItems="center"
    justifyContent="space-between"
    testID="somethingChangedBanner"
  >
    <HeaderText color={colors.whiteWash} level={3}>
      Your {editType} has changed
    </HeaderText>
    <PortalOverlayHeaderCloseBtn
      testID="dismissFraudBanner"
      onCloseRequest={onDismiss}
      color={colors.whiteWash}
    />
  </Inline>
);

export default FraudBanner;
